import React, {useState, Fragment}from 'react'
import { Link } from 'react-router-dom';
import Image from '../Image'
import parse from 'html-react-parser';
import {currentLang, farmerURL} from '../../../utils/functions';
//import noImage from '../../../assets/img/frank_wennekers_1.jpg'
import { useTranslation } from 'react-i18next';
import {isNil, upperFirst} from 'lodash';
import W from '../../../components/ui/Word';


const ProfileFarmer = ({name, body, link, image, title, location, earnumber, breeds, isnew, animal}) => {
  const [toggled, setToggled] = useState(false);
  const { t } = useTranslation();
  const url = farmerURL(((isnew == 1) ? t("farmers.newfarmerslug")+"/"+t(animal) : link));

  function HandleTooltipPopup(event) {
    event.preventDefault()
    setToggled(!toggled)
  }

    let toggledClass = (toggled) ? "" : "";
    //console.log(link);
    return (
      <Fragment>
      <div className={`farmer tooltip tooltip--left`}>
        <div className="profile tooltip__info">
          <a className="tooltip__info--link" onClick={HandleTooltipPopup}></a>
          <div className="avatar">
            {image ? <Image src={image} /> : <span className="icon-farmers"></span>}
          </div>
          <div className="info">
            <span className="title"> <span className="icon-info"></span> {title} </span>
          </div>
        </div>
        <div className={`tooltip__content tooltip__farmers ${toggledClass}`}>
          <a className="icon-close align__right" onClick={HandleTooltipPopup}></a>
          <div className="tooltip__content--info famers__info">
            <div className="row">
              <div className="col-4 tooltip__content--icon famers__info">
                <span className="icon-farmers"></span>
              </div>
              <div className="col-8 tooltip__content--list famers__info">
                <ul className="list list--no-list">
                  {!['game', 'deer', 'boar'].includes(animal) &&
                    <li className="farmers--name"> {title} </li>
                  }
                  <li className="farmers--location">{upperFirst(t('farmers.location'))}: <strong>{location}</strong> </li>
                  {breeds &&
                  <li className="farmers--breed">{upperFirst(t('farmers.breeds'))}:
                  <strong>
                    {
                      /*breeds && breeds.map(item=>{
                        return <span>{item.title}</span>
                      })*/
                      breeds && " "+breeds
                    }
                  </strong>
                  </li>
                  }
                  {earnumber &&
                  <li className="farmers--ear-number">{upperFirst(t('product.earnumber.'+animal))}: <strong>{earnumber}</strong> </li>
                  }
                </ul>
              </div>
            </div>
          </div>
          <div className="body">{body && parse(body)}</div>

            {['game', 'roe', 'deer', 'boar'].includes(animal) &&
                <a href={url}>
                  <W>farmers.readmoreaboutfarmer_deer</W>
                </a>
            }
            {['fish', 'salmon'].includes(animal) &&
                <a href={url}>
                  <W>farmers.readmoreaboutfarmer_fish</W>
                </a>
            }
            {!['game', 'roe', 'deer', 'boar', 'fish', 'salmon'].includes(animal) &&
                <a href={url}>
                  <W>farmers.readmoreaboutfarmer</W>
                </a>
            }
            {/*<a href={"/"+currentLang()+"/"+t("menu.farmers")+"/"+((isnew == 1) ? t("farmers.newfarmerslug")+"/"+t(animal) : link)}>
              <W>farmers.readmoreaboutfarmer</W>
            </a>
            */}
        </div>
      </div>
    </Fragment>
    )
}

export default ProfileFarmer
